/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChipsElementModel } from '../../../../shared/chips-autocomplete/chips-autocomplete.component';
import { DateFilterValue } from '../../../../shared/date-range-picker/date-range-picker.component';

@Component({
  selector: 'app-workflow-filter-toolbar',
  templateUrl: './workflow-filter-toolbar.component.html',
  styleUrls: ['./workflow-filter-toolbar.component.scss'],
  standalone: false
})
export class WorkflowFilterToolbarComponent {
  @Input() executedByText!: string;
  @Input() selectEmployeesPlaceholder!: string;
  @Input() availableEmployees: ChipsElementModel[] = [];
  @Input() selectedEmployeeIds: string[] = [];
  @Input() dateFilterValue!: DateFilterValue;

  @Output() employeeSelectionChange = new EventEmitter<{ id: string; type?: string }[]>();
  @Output() dateFilterChange = new EventEmitter<DateFilterValue>();

  onEmployeeSelectionChange(selection: { id: string; type?: string }[]): void {
    this.employeeSelectionChange.emit(selection);
  }

  onDateFilterChange(filter: DateFilterValue): void {
    this.dateFilterChange.emit(filter);
  }
}
